<table mat-table [dataSource]="values" class="mat-elevation-z8 cf-table" aria-hidden="true">

  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef> Field Name </th>
    <td mat-cell *matCellDef="let element">
      <span class="cf-name">
        {{element.name}}
        <span *ngIf="element.helpText?.length">
          <a matTooltip="{{element.helpText}}" [matTooltipPosition]="'above'" class="help-link">?
          </a>
        </span>
      </span>
    </td>
  </ng-container>

  <ng-container matColumnDef="value">
    <th mat-header-cell *matHeaderCellDef> Value </th>
    <td mat-cell *matCellDef="let element">{{element.value || 'N/A'}}</td>
  </ng-container>

  <ng-container *ngIf="!isLoading">
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="displayedColumns.length">
        No custom fields found.
      </td>
    </tr>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

</table>